import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface RegisteredTradesGroupingObject {
  id: number;
  slug: string;
  titleEn: string;
  titleAr: string;
  icon: string;
  sort: number;
  isActive: boolean;
}

export interface RegisteredTradesGroupingListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  registeredTradesGroupings: Array<RegisteredTradesGroupingObject>;
  errors: unknown;
}

@Module
export default class RegisteredTradesGroupingModule
  extends VuexModule
  implements RegisteredTradesGroupingListInfo
{
  registeredTradesGroupings = [] as Array<RegisteredTradesGroupingObject>;
  listDdlRegisteredTradesGroupings =
    [] as Array<RegisteredTradesGroupingObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get RegisteredTradesGroupings list
   * @returns Array<RegisteredTradesGroupingObject>
   */
  get registeredTradesGroupingsList(): Array<RegisteredTradesGroupingObject> {
    return this.registeredTradesGroupings;
  }

  /**
   * Get all none ive RegisteredTradesGroupings list
   * @returns Array<RegisteredTradesGroupingObject>
   */
  get allListRegisteredTradesGroupings(): Array<RegisteredTradesGroupingObject> {
    return this.listDdlRegisteredTradesGroupings;
  }

  /**
   * Get total items
   * @returns number
   */
  get registeredTradesGroupingsListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_REGISTERED_TRADES_GROUPINGS](data) {
    this.registeredTradesGroupings = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_REGISTERED_TRADES_GROUPINGS_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.SET_ALL_REGISTERED_TRADES_GROUPINGS](data) {
    this.listDdlRegisteredTradesGroupings = data.data;
  }

  @Mutation
  [Mutations.RESET_REGISTERED_TRADES_GROUPINGS_LIST]() {
    this.registeredTradesGroupings =
      [] as Array<RegisteredTradesGroupingObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_REGISTERED_TRADES_GROUPINGS_STORE]() {
    this.context.commit(Mutations.RESET_REGISTERED_TRADES_GROUPINGS_LIST);
  }

  @Action
  [Actions.CREATE_REGISTERED_TRADES_GROUPING](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/registered-trades-grouping', data)
      .then(({ data }) => {
        this.context.commit(Mutations.RESET_REGISTERED_TRADES_GROUPINGS_LIST);
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_REGISTERED_TRADES_GROUPING](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/registered-trades-grouping', id)
      .then(() => {
        this.context.commit(Mutations.RESET_REGISTERED_TRADES_GROUPINGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_REGISTERED_TRADES_GROUPING]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/registered-trades-grouping', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_REGISTERED_TRADES_GROUPINGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_REGISTERED_TRADES_GROUPING_CURRENT_PAGE](val) {
    this.context.commit(
      Mutations.SET_REGISTERED_TRADES_GROUPINGS_CURRENT_PAGE,
      val
    );
  }

  @Action
  [Actions.GET_REGISTERED_TRADES_GROUPING](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/registered-trades-grouping', id);
  }

  @Action
  [Actions.GET_REGISTERED_TRADES_GROUPINGS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/registered-trades-grouping', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_REGISTERED_TRADES_GROUPINGS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_ALL_REGISTERED_TRADES_GROUPINGS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/registered-trades-grouping/all')
      .then(({ data }) => {
        this.context.commit(
          Mutations.SET_ALL_REGISTERED_TRADES_GROUPINGS,
          data
        );
        return data.data;
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.UPLOAD_REGISTERED_TRADES_ICON]({ data, groupingId }) {
    ApiService.setAuthorizationHeader();
    ApiService.setMultipartHeader();
    return ApiService.post(
      `/registered-trades-grouping/uploadIcon/${groupingId}`,
      data
    )
      .then(({ data }) => {
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
}
